module.exports = __webpack_public_path__ + "static/media/exercise.fd20bc7c.jpg";